<div class="team-leadership-codex-container">
    <p-card>
        <div class="card-header">
            <h1>Leadership Codex</h1>
            <p-dropdown [options]="teamCodexReports" (onChange)="sortCurrentAndPreviousReport($event.value.index)" optionLabel="quarter" dropdownIcon="bi bi-caret-down-fill"></p-dropdown>
            <button *ngIf="isUserEligibleToSeeMore" class="codex-see-more-btn" (click)="seeMore()" pButton label="See more"></button>
        </div>
        <div class="card-body">
            <div class="overall-score-container">
                <h1 class="overall-score-container-title">{{'score' | translate}}</h1>
                <app-gauge-display
                    [value]="currentReport.score.value"
                    [width]="215"
                    [height]="190"
                    [isOnTeamCodex]="true"
                    [trend]="currentReport.score.trend"
                    [colorStart]="currentReport.score.color"
                    [colorEnd]="currentReport.score.color"
                    [backgroundColor]="'rgba(240, 243, 250, 1)'">
                </app-gauge-display>
                <div class="change-index-container">
                    <div class="change-index-value">
                        <img [class]="'arrow-' + currentReport.score.diff.trend" [src]="'../../../assets/svg/indicator-arrow-'+currentReport.score.diff.trend+'.svg'">
                        <span class="change-index-value-diff">{{(currentReport.score.diff.value > 0) ? ('+'+currentReport.score.diff.value+'%'):(currentReport.score.diff.value+'%')}}</span>
                    </div>
                    <span class="change-index-value-text">{{'wo_codex_progress_change'|translate}}</span>
                </div>
            </div>
            <div class="topics-main-container">
                <div class="topic-container">
                    <span class="topic-container-title">{{ 'wo_codex_highest' | translate }}</span>
                    <div class="topic-indicator-container">
                        <div [ngStyle]="{'background-image':currentReport.highestTopic.gradientColor}" class="topic-indicator-icon-container">
                            <img [src]="'../../../assets/icons/codex/'+currentReport.highestTopic.category.slug+'.svg'">
                        </div>
                        <span class="topic-indicator-title">{{currentReport.highestTopic.category.title}}</span>
                        <div class="topic-indicator-value-container">
                            <span class="topic-indicator-value">{{currentReport.highestTopic.score}}</span>
                            <span class="topic-indicator-value-percentage">%</span>
                            <img class="topic-indicator-trend" *ngIf="currentReport.highestTopic.comparison.trend" 
                                [class]="'arrow-' + currentReport.highestTopic.comparison.trend" 
                                [src]="'../../../assets/svg/indicator-arrow-'+currentReport.highestTopic.comparison.trend+'.svg'">
                        </div>
                    </div>
                </div>
                <div class="topic-container">
                    <span class="topic-container-title">{{ 'wo_codex_lowest' | translate }}</span>
                    <div class="topic-indicator-container">
                        <div [ngStyle]="{'background-image':currentReport.lowestTopic.gradientColor}" class="topic-indicator-icon-container">
                            <img [src]="'../../../assets/icons/codex/'+currentReport.lowestTopic.category.slug+'.svg'">
                        </div>
                        <span class="topic-indicator-title">{{currentReport.lowestTopic.category.title}}</span>
                        <div class="topic-indicator-value-container">
                            <span class="topic-indicator-value">{{currentReport.lowestTopic.score}}</span>
                            <span class="topic-indicator-value-percentage">%</span>
                            <img class="topic-indicator-trend" *ngIf="currentReport.lowestTopic.comparison.trend" 
                                [class]="'arrow-' + currentReport.lowestTopic.comparison.trend" 
                                [src]="'../../../assets/svg/indicator-arrow-'+currentReport.lowestTopic.comparison.trend+'.svg'">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </p-card>
</div>